import {
  Box,
  TextFieldProps,
  TextField,
  Button,
  IconButton,
} from "@material-ui/core";
import React from "react";
import {
  ControllerRenderProps,
  Control,
  Controller,
  FormState,
  ControllerFieldState,
  useController,
} from "react-hook-form";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import TextFieldWrapper from "@components/wrappers/field/text";

type RenderProps = {
  field: ControllerRenderProps<Record<string, any>, string>;
  fieldState: ControllerFieldState;
  formState: FormState<Record<string, any>>;
};

interface Props {
  name: string;
  control: Control<any>;
  textFieldProps: TextFieldProps;
}

export default function PasswordFieldWrapper(props: Props): JSX.Element {
  const { name, control, textFieldProps } = props;

  const [visible, setVisible] = React.useState(false);
  const toggleVisible = () => {
    setVisible(!visible);
  };

  return (
    <TextFieldWrapper
      control={control}
      name={name}
      textFieldProps={{
        ...textFieldProps,
        type: visible ? "text" : "password",
        InputProps: {
          ...(textFieldProps.InputProps || {}),
          endAdornment: (
            <IconButton onClick={toggleVisible}>
              {visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          ),
        },
      }}
    />
  );
}
